import { graphql } from 'react-apollo';

import type AuthoringCourse from 'bundles/author-common/models/AuthoringCourse';
import WeekToModuleStatusQuery from 'bundles/custom-labels/queries/CourseIsWeekToModuleEnabled.graphql';
import type {
  WeekToModuleStatusQuery as WeekToModuleStatusQueryResponse,
  WeekToModuleStatusQueryVariables,
} from 'bundles/custom-labels/queries/__generated__/CourseIsWeekToModuleEnabled';

type OuterProps = {
  course?: AuthoringCourse;
  courseId?: string;
};

type InnerProps = { isWeekToModuleEnabledForCourse: boolean };

export const withIsWeekToModuleEnabledForCourse = <PropsFromCaller extends OuterProps>(
  Component: React.ComponentType<PropsFromCaller & InnerProps>
) =>
  graphql<PropsFromCaller, WeekToModuleStatusQueryResponse, WeekToModuleStatusQueryVariables, InnerProps>(
    WeekToModuleStatusQuery,
    {
      skip: ({ course, courseId }) => !courseId && !course?.id,
      options: ({ course, courseId }) => ({
        variables: {
          courseId: course ? course.id : `${courseId}`,
        },
        context: {
          clientName: 'gatewayGql',
        },
      }),
      props: ({ data }) => {
        return {
          isWeekToModuleEnabledForCourse: !!data?.Course?.queryById?.isWeekToModuleEnabledForCourse,
        };
      },
    }
  )(Component);
